import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import properties from '../../modules/ajio-util/properties';
import { FacebookLoginButton } from './FacebookLoginButton';
import { accountCheck, socialAuth, generateLoginOTP } from '../actions/signinAction';
import { hideModal } from '../../actions/modal.js';
import { showLoader } from '../../actions/shared/loader';
import SignUpSocial from './SignUpSocial';
import cleverTapPushEvent from '../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../modules/ajio-util/cleverTap/eventConstants';
import { createRedirectUri } from '../../utils/redirectUtil';
import { getGoogleAuthUrl } from '../../utils/loginUtil';
import { requestType } from '../../constants/constant.js';
import { getUseRevampedGoogleAuth } from '../../Flags/selectors';
import { gtmEventPush, gtmPagePush, segmentEventPush } from '../../modules/ga/GTMdatalayer';
import { signInCheck } from '../../components/common/CheckUserStatus';
import screens from '../../refresh/constants/pageType.constant';
import { parseSearch } from '../../modules/ajio-util/query';

import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';
import { getAssetConfig, getUaas } from '../../refresh/selectors/featureFlagsSelector';

class SocialAccount extends React.Component {
  constructor(props) {
    super(props);
    this.checkAccUser = this.checkAccUser.bind(this);
    this.responseGoogle = this.responseGoogle.bind(this);
    this.onFacebookLogin = this.onFacebookLogin.bind(this);
    this.state = {
      username: null,
      showNumVerification: false,
      loginVia: '',
      userEmail: '',
      returnedToken: '',
      errorMsg: '',
      googleAuthUrl: ''
    };
  }

  componentDidMount() {
    const { flags = {}, callPageLoad } = this.props;
    const useRevampedGoogleAuth = getUseRevampedGoogleAuth(flags);
    if (useRevampedGoogleAuth) {
      this.setState({ googleAuthUrl: getGoogleAuthUrl() });
    }
    const loginStatus = signInCheck().length ? 'Login' : 'Not Login';
    const { login_password: { pageType = '', pageName = '' } = {} } = screen;
    const { location: { search = '' } = {} } = window;
    const queryObj = parseSearch(search) || '';
    const { referrer = '', login_source = '' } = queryObj;
    if (callPageLoad || callPageLoad == undefined) {
      gtmEventPush({
        event: 'pageload',
        login_method: 'password',
        referral_page: referrer.slice(1),
        login_source,
        user_type: loginStatus,
        page_type: pageType,
        page_name: pageName
      });
    }
  }

  // var socialAuthObj;
  checkAccUser(viewSiteAs) {
    var usernameObj = { emailId: this.state.userEmail, profileId: this.state.userId };
    const { queryString = '', location: { pathname = '' } = {} } = this.props;
    let gaLabelSuccess = `Sign in with ${this.state.loginVia} - Success`;
    let gaLabelFailure = `Sign in with ${this.state.loginVia} - Failure`;

    this.props.accountCheck(usernameObj, (checkResponse = {}) => {
      /* If user exists, authenticate user's social login */
      let logInInfo = this.state.userEmail;
      if (logInInfo === '') {
        logInInfo = checkResponse.maskedEmailId;
      }
      var socialAuthObj = {
        login: logInInfo,
        loginvia: this.state.loginVia,
        token: this.state.returnedToken,
        profileId: this.state.userId
      };
      if (this.props?.isUaasOn) {
        socialAuthObj = {
          login: logInInfo,
          loginVia: this.state.loginVia,
          token: this.state.returnedToken,
          profileId: this.state.userId
        };
      }
      const { maskedEmailId = '' } = checkResponse;
      if (this.props.accCheck) {
        this.props.socialAuth(
          socialAuthObj,
          () => {
            if (this.props.social !== {}) {
              const redirectURI = createRedirectUri(queryString);
              if (viewSiteAs == 'desktop') {
                ga('send', {
                  eventCategory: 'Login',
                  eventAction: "Glad you're back",
                  eventLabel: gaLabelSuccess
                });
                gtmEventPush({
                  page_name: 'Login Social screen',
                  page_type: 'user account screen',
                  event: 'user_account_interactions',
                  category: 'user account interactions',
                  action: this.state.loginVia,
                  label: 'Start shopping - success'
                });
                if (pathname && pathname == '/login') {
                  window.location = redirectURI;
                } else {
                  this.props.hideModal('sign-in-up');
                  let { location: { href = '' } = {} } = window;
                  if (!href.includes('/cart')) {
                    window.location.reload();
                  }
                }
              } else {
                ga('send', {
                  eventCategory: 'Login',
                  eventAction: "Glad you're back",
                  eventLabel: gaLabelSuccess
                });
                window.location = redirectURI;
              }
            } else {
              if (this.props.statusCode > 400) {
                this.setState({ errorMsg: 'ERROR!!!' });
              }
              gtmEventPush({
                page_name: 'Login Social screen',
                page_type: 'user account screen',
                event: 'user_account_interactions',
                category: 'user account interactions',
                action: this.state.loginVia,
                label: 'Start shopping - failure'
              });
            }
          },
          viewSiteAs,
          () => {
            this.props.generateLoginOTP(usernameObj, () => {
              if (viewSiteAs == 'desktop') {
                this.props.setSocialAccExists();
              } else {
                this.props.showLoader('auth-modal-loader');
                const search = this.props?.location?.search || '';
                const href = `/login/otp${search}`;
                window.location.href = href;
              }
            });
          }
        );
      } else {
        // when new user and wants to sign up
        if (viewSiteAs == 'desktop') {
          this.setState({
            showNumVerification: true
          });
          this.props.socialSignIn('signup'); // sending info to parent about signup
        } else {
          this.setState({
            showNumVerification: true
          });
          this.props.socialSignIn('signup');
          // window.location = '/signup/social'+"?referrer="+this.props.referrer ;
        }
      }
    });
  }

  responseGoogle(response) {
    let { profileObj = {}, tokenId = '', accessToken = '' } = response;
    let {
      email = '',
      familyName = '',
      givenName = '',
      googleId = '',
      imageUrl = '',
      name = ''
    } = profileObj;

    this.setState(
      { username: name, userEmail: email, loginVia: 'google', returnedToken: tokenId },
      () => {
        if (this.state.userEmail) {
          // ga('send', {
          //   eventCategory: 'Login',
          //   eventAction: "Welcome to AJIO",
          //   eventLabel: 'Google button click - Success'
          // });
          const loginStatus = signInCheck().length ? 'Login' : 'Not Login';
          // const { signup_otp: { pageType = '', pageName = '' } = {} } = screen;
          const { location: { search = '' } = {} } = window;
          const queryObj = parseSearch(search) || '';
          const { referrer = '', login_source = '' } = queryObj;
          gtmEventPush({
            event: 'login_success',
            login_method: 'google',
            referral_page: referrer.slice(1),
            login_source,
            user_type: loginStatus,
            page_type: 'user account screen',
            page_name: 'google login screen'
          });

         segmentEventPush({
            event: 'Login or Signup Successful',           
            gender : '',
            referral_code: '',
            screen_name: 'google login screen',
            type: `google`,
          });
        
          cleverTapPushEvent({
            eventName: CLEVERTAP_EVENT_NAMES.User_Sign_In,
            eventObj: {
              source: 'Sign In Page',
              type: 'Login Via Google',
              user_id: this.state.userEmail,
              platform: 'MSITE'
            }
          });
          this.checkAccUser(this.props.viewSiteAs);
        } else {
          ga('send', {
            eventCategory: 'Login',
            eventAction: 'Welcome to AJIO',
            eventLabel: 'Google button click - Failure'
          });
        }
      }
    );
  }

  onFacebookLogin = (loginStatus, resultObject) => {
    let {
      user: { name = '', email = '', id = '' } = {},
      authResponse: { accessToken = '', expiresIn = '', signedRequest = '', userID = '' } = {}
    } = resultObject;

    if (loginStatus === true) {
      // ga('send', {
      //   eventCategory: 'Login',
      //   eventAction: "Welcome to AJIO",
      //   eventLabel: 'Facebook button click - Success'
      // });
      const checkloginStatus = signInCheck().length ? 'Login' : 'Not Login';
      // const { signup_otp: { pageType = '', pageName = '' } = {} } = screen;
      const { location: { search = '' } = {} } = window;
      const queryObj = parseSearch(search) || '';
      const { referrer = '', login_source = '' } = queryObj;
      gtmEventPush({
        event: 'login_success',
        login_method: 'Facebook',
        referral_page: referrer.slice(1),
        login_source,
        user_type: checkloginStatus,
        page_type: 'user account screen',
        page_name: 'facebook login screen'
      });

      segmentEventPush({
          event: 'Login or Signup Successful',           
          gender : '',
          referral_code: '',
          screen_name: 'facebook login screen',
          type: `Facebook`,
      });
        


      cleverTapPushEvent({
        eventName: CLEVERTAP_EVENT_NAMES.User_Sign_In,
        eventObj: {
          source: 'Sign In Page',
          type: 'Login Via Facebook',
          user_id: this.state.userEmail,
          platform: 'MSITE'
        }
      });
      this.setState(
        {
          username: name,
          userEmail: email,
          userId: id,
          loginVia: 'facebook',
          returnedToken: accessToken
        },
        () => {
          return this.checkAccUser(this.props.viewSiteAs);
        }
      );
    } else {
      alert('Facebook login error');
      ga('send', {
        eventCategory: 'Login',
        eventAction: 'Welcome to AJIO',
        eventLabel: 'Facebook button click - Failure'
      });
    }
  };

  googleResponseFailed = failedResponse => {
    console.error('google auth response failed', failedResponse);
  };

  handleGa = () => {
    const { login_signup: { pageType = '', pageName = '' } = {} } = screens;
    gtmEventPush({
      event: 'user_account_interactions',
      category: 'user account interactions',
      action: 'google',
      label: 'Started',
      page_type: pageType,
      page_name: 'login/signup screen'
    });
    segmentEventPush({
      event:'Social Login Clicked',
      channel_used : 'google',
      screen_name: 'login/signup screen'
    });
  };

  openGoogleAuthTab = () => {
    this.handleGa();
    window.googleAuthComplete = this.responseGoogle;
    window.open(this.state.googleAuthUrl, 'Google Authentication');
  };

  render() {
    const { viewSiteAs = '', queryString = '', flags = {}, newDesignLuxe, assetConfig = {} } = this.props;
     const isJioCDNEnabled = assetConfig && assetConfig.isJioCDNEnabled === 'ON';
    let imageBaseUrl = properties.getProperty('imageBaseUrl') || 'https://assets-jiocdn.ajio.com';
    const useRevampedGoogleAuth = getUseRevampedGoogleAuth(flags);
    const { username = '', email = '' } = this.state;
    if (this.state.showNumVerification) {
      var socialAuthObj = {
        firstName: this.state.username,
        login: this.state.userEmail,
        password: '',
        token: this.state.returnedToken,
        genderType: '',
        requestType: requestType.SENDOTP,
        loginvia: this.state.loginVia,
        profileId: this.state.userId
      };
      return (
        <SignUpSocial
          socialLoginInfo={socialAuthObj}
          viewSiteAs={viewSiteAs}
          queryString={queryString}
        />
      );
    } else {
      return (
        <div className={newDesignLuxe ? 'luxe-newdesign' : ''}>
          <h2 role="presentation">{newDesignLuxe ? 'Join / Sign In Using' : 'Join / Sign In using'}</h2>
          {!username && (
            <div className="social-login">
              <FacebookLoginButton onLogin={this.onFacebookLogin}>
                <div
                  data-ga-event-category="Login"
                  data-ga-event-action="Welcome to AJIO"
                  data-ga-event-label="Facebook button clicked - failed/success"
                >
                  <span className="fb-icon"  style={{
                    backgroundImage: `url(${`${imageBaseUrl}/static/img/fb.png`})`,
                    backgroundRepeat: 'repeat-x'
                  }}/>
                  <span className={`social-txt ${newDesignLuxe ? 'facebooktext' : ''}`}>
                    Facebook
                  </span>
                </div>
              </FacebookLoginButton>
              {useRevampedGoogleAuth ? (
                <div
                  className="google-login"
                  onClick={this.openGoogleAuthTab}
                  tabIndex={0}
                  role="button"
                >
                  <span className="google-icon" style={{
                    backgroundImage: `url(${`${imageBaseUrl}/static/img/google.png`})`,
                    backgroundRepeat: 'repeat-x'
                   }}/>
                  <span className="social-txt">Google</span>
                </div>
              ) : (
              <GoogleOAuthProvider clientId={properties.getProperty('googleClientId')}>
                <GoogleLogin
                  className="google-login"
                  clientId={`${properties.getProperty('googleClientId')}`}
                  onSuccess={this.responseGoogle}
                  onFailure={this.googleResponseFailed}
                  cookiePolicy="single_host_origin"
                >
                  <div onClick={this.handleGa}>
                    <span className="google-icon" style={{
                      backgroundImage: `url(${`${imageBaseUrl}/static/img/google.png`})`,
                      backgroundRepeat: 'repeat-x'
                    }} />
                    <span className="social-txt">Google</span>
                  </div>
                </GoogleLogin>
              </GoogleOAuthProvider>
              )}
            </div>
          )}
          <div>{username && <p>Welcome back, {username}.</p>}</div>
          <div className="or-separator">
            {' '}
            <hr aria-hidden="true"/>{' '}
            <span className={viewSiteAs == 'desktop' ? 'or-text-desktop' : 'or-text'}>
              {' '}
              Or{' '}
            </span>{' '}
            <hr aria-hidden="true"/>{' '}
          </div>
        </div>
      );
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    accountCheck: (formData, callback) => {
      dispatch(accountCheck(formData, callback));
    },
    fbSignIn: () => {
      dispatch(fbSignIn());
    },
    socialAuth: (formData, callback, device, catchCallback) => {
      dispatch(socialAuth(formData, callback, device, catchCallback));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    showLoader: name => {
      dispatch(showLoader(name));
    },
    generateLoginOTP: (formData, callback) => {
      dispatch(generateLoginOTP(formData, callback));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const { signInReducer = {}, httpError = {}, flags = {} } = state;
  const { error = {} } = httpError;
  const { redirectToOTP = false } = error;
  const { success = false, emailId = '', social = {} } = signInReducer;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const isUaasOn = getUaas(state);
  const assetConfig = getAssetConfig(state?.flags);
  return {
    newDesignLuxe,
    accCheck: success,
    emailId,
    social,
    httpError,
    statusCode: error.statusCode,
    redirectToOTP,
    flags,
    isUaasOn,
    assetConfig
  };
};

export default SocialAccount = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SocialAccount)
);
